import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Modal = styled.div`
  z-index: 999999999;
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000000de;
`;

export const ModalContainer = styled.div`
  background: blue;

  width: 300px;
  height: 300px;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  border-radius: 25px;
  padding: 20px;

  background: white;

  ul {
    display: flex;
    flex-direction: column;
    position: relative;
    width: unset;
    margin: unset;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
    justify-content: center;
    text-align: center;
    height: 100%;

    li {
      height: 100%;
      border-radius: unset;
      background: unset;
      list-style: none;
      margin-left: 20px;
      color: var(--white);
      transition: color 0.5s;
      margin: 15px;
      
      &:not(.spotlight):hover {
        color: var(--secondary);
        transition: color 0.5s;
      }
    }
    
    .spotlight {
      background: var(--primary);
      height: 30px;
      border-radius: 7px;
      align-items: center;
      display: flex;
      color: var(--white);
      font-weight: bold;
      width: 150px;
      height: 40px;

      &:hover {
        transition: all 0.5s;
        background: var(--secondary);
        cursor: pointer;
      }
    }

    a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;